import { reactive } from 'vue'

export const siteStatus = reactive({ closed: false, reason: '' })

export function handleSiteStatus(result) {
  if (Number(result.error_code) === 1007) {
    siteStatus.closed = true
    siteStatus.reason = result.error_msg || '站点已经关闭，请稍后访问'
  }
}
